class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      console.log('Test Remove')
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);

      var getitemlocal = localStorage.getItem('timercount');
      console.log('getitemlocal',getitemlocal);
       setTimeout(function(){
         $('.upcart_announcement').hide();
          }, 2000);
      if(getitemlocal != ''){
      }
      var itemlen = $('.cart-item').length;
      if(itemlen == 1){
        localStorage.removeItem('timercount');
      }

      // style product
       var cartstyle_pro = $(this).attr('data-product-id');
        console.log(cartstyle_pro,'cartstyle_pro');

        setTimeout(function(){
         if(cartstyle_pro == '42459357151391'){
          console.log('find..');
           localStorage.removeItem('lastAddedProductId');
           $('.style-with-product').show();
           var GuaranteeIdIdwithpageload = localStorage.getItem('GuaranteeIdId');
           if(GuaranteeIdIdwithpageload){
            $('.Guarantee_btn_check').trigger('click');
          }
        }
        if(cartstyle_pro == '43672119181471'){
          localStorage.removeItem('GuaranteeIdId');
           console.log('find..11');
          var Style_withpageload = localStorage.getItem('lastAddedProductId');
          if(Style_withpageload){
            $('.style-with-product').hide();
          }
           // $('.Guarantee_btn_check').trigger('click'); 
        }
        if(cartstyle_pro == '44874618208415'){
             console.log('find..package');
            localStorage.setItem('upsellId','44874616995999');
            $('input[data-product-id="44874618208415"]').prop('checked', false);
            $('input[data-product-id="44874616995999"]').prop('checked', true);
        }
        
        }, 1000);

      
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    console.log('updateQuantity');
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
        // console.log(parsedState,'parsedState.item_count');

        // updatepackaging quantity
        var getupsell = localStorage.getItem('upsellId');
        if(getupsell == 44874618208415){
        console.log('package..');
        $('input[data-product-id="44874618208415"]').prop('checked', true);
        $('input[data-product-id="44874616995999"]').prop('checked', false);
      }else{
        console.log('gift..');
        $('input[data-product-id="44874618208415"]').prop('checked', false);
        $('input[data-product-id="44874616995999"]').prop('checked', true);
      }
        // Your condition checking and cart clearing logic
function checkAndClearCart(parsedState) {
  // Check if item_count is 2
  if (parsedState.item_count === 2) {
    // Assuming the cart items are stored in an array named 'items' within parsedState
    const ids = parsedState.items.map(item => item.id.toString()); // Convert IDs to string to ensure matching
    const requiredIds = ["43672119181471", "44874616995999"];
    
    // Check if both product IDs exist in the cart
    const hasAllRequiredProducts = requiredIds.every(id => ids.includes(id));
    console.log(ids,'hasAllRequiredProducts');
    
    if (hasAllRequiredProducts) {
      // Logic to clear the cart goes here
      console.log("Clearing cart because it contains the specific products and item count is 2");
      // Shopify.clear(); // This function would actually clear the cart, you need to replace it with your actual cart clearing function/method
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() {
          clearCart;
          localStorage.removeItem('GuaranteeIdId');
          localStorage.removeItem('upsellId');
          $("cart-drawer").load(location.href + " cart-drawer>*", "");
          $('cart-drawer').addClass('is-empty');
          $(".header__icon--cart").load(location.href + " .header__icon--cart>*", "");
        },
        error: function(XMLHttpRequest, textStatus) {
          /* error code */
        }
      });
    } else {
      console.log("Cart does not contain the specific products or does not have exactly 2 items");
    }
  }

  // == one CartItems
  if (parsedState.item_count === 1) {
    // Assuming the cart items are stored in an array named 'items' within parsedState
    const ids = parsedState.items.map(item => item.id.toString()); // Convert IDs to string to ensure matching
    const requiredIds = ["44874616995999"];
    
    // Check if both product IDs exist in the cart
    const hasAllRequiredProducts = requiredIds.every(id => ids.includes(id));
    console.log(ids,'hasAllRequiredProducts');
    
    if (hasAllRequiredProducts) {
      // Logic to clear the cart goes here
      console.log("Clearing cart because it contains the specific products and item count is 2");
      // Shopify.clear(); // This function would actually clear the cart, you need to replace it with your actual cart clearing function/method
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() {
          clearCart;
          localStorage.removeItem('GuaranteeIdId');
          localStorage.removeItem('upsellId');
          $("cart-drawer").load(location.href + " cart-drawer>*", "");
          $('cart-drawer').addClass('is-empty');
          $(".header__icon--cart").load(location.href + " .header__icon--cart>*", "");
        },
        error: function(XMLHttpRequest, textStatus) {
          /* error code */
        }
      });
    } else {
      console.log("Cart does not contain the specific products or does not have exactly 2 items");
    }
  }

  setTimeout(function(){
    var checkedValue = $('input[name="selected-product"]:checked').attr('data-product-id');
    var uncheckedValue = $('input[name="selected-product"]:not(:checked)').attr('data-product-id');
    console.log('redio update',checkedValue, uncheckedValue);

    var matchFound = false;
    $("cart-remove-button").each(function() {
      var cartID = $(this).attr('data-product-id');
      console.log(cartID,'cartID');
      if (checkedValue == cartID) {
          matchFound = true; 
          return false; 
      }
    });
    if (matchFound) {
      console.log("Match found!...cart.js");
    } else {
      addItem(checkedValue, 1);
    }
  }, 1000);
}
function clearCart() {
  Shopify.clear();
}
// Example usage
checkAndClearCart(parsedState)
        // == end
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};


